export const FLAGS = {
  /** Golden Gurls Flags */
  ggCustomImageAds: 'ggKioskCustomImageAds',
  ggOneClickCheckout: 'ggOneClickCheckout',
  goldAchOnKiosk: 'ggGoldAchOnKiosk',
  goldBundles: 'ggJaneGoldBundles',
  ggMfaCheck: 'ggMfaCheck',
  kioskOrderConfirmationRating: 'kioskOrderConfirmationRatingEnabled',
  reeferMigration: 'fepReeferMigration',

  /** Bargain Buds Flags */
  bbExcludeQualifiersFromProductDiscounts:
    'bbExcludeQualifiersFromProductDiscounts',

  /** Cannabinerds Flags */
  cnShowWeekendLookaheadControls: 'cnShowWeekendLookaheadControls',
  cnSpecialDetailPageNsw: 'cnSpecialDetailPageNsw',
  cnShowKioskNotificationsCard: 'cnShowKioskNotificationsCard',
  cnSkipRedundantDebouncedUpdate: 'cnSkipRedundantDebouncedUpdate',
  cnUseGeofenceSchedules: 'cnUseGeofenceSchedules',
  cnUseRulesForMenuRows: 'cnUseRulesForMenuRows',

  /** Sour Chiesel Flags */
  scMenuRowConditionsFe: 'scMenuRowConditionsFe',
  scSmsIntegration: 'sourChieselStoreSpecificSmsIntegrationUi',
  scNotificationSettingsCardAccess: 'scNotificationSettingsCardAccess',
  scSpecialsBetaAccess: 'sourChieselSpecialsBetaAccess',
  scGlobalSpecialsBeta: 'sourChieselGlobalSpecialsBeta',
  scQuickActionBeta: 'scQuickActionBeta',
  scShowMenuRowIdInModal: 'scShowMenuRowIdInModal',
  scStackingSettingsPosStores: 'scStackingSettingsForPosStores',
  scBulkSpecialsExtraWeightsFrontend: 'scBulkSpecialsExtraWeightsFrontend',
  scMenuRowSchedulingFe: 'scMenuRowSchedulingFe',
  scSpendThresholdSpecialsFrontend: 'scSpendThresholdSpecialsFrontend',
  scSpecialsCustomBadge: 'scSpecialsCustomBadge',
  scMenuRowSubcategoryAndCategory: 'menuRowSubcategoryAndCategory',
  scPrintDismissedOrdersSetting: 'scPrintDismissedOrdersSetting',
  scHideSpecialsAccess: 'scHideSpecialsAccess',
  scShowGlobalBoostMenusPage: 'scShowGlobalBoostMenusPage',
  scWeightValuesFrontend: 'scWeightValuesFrontend',
  scTerpeneFiltersMarketplace: 'scTerpeneFiltersMarketplace',
  scDisplayProductNonStandardWeight: 'scDisplayProductNonStandardWeight',
  // Usually SC flags are in the Manager project, but this one is in Consumer since it's used in Legacy Biz Admin
  consumerBoostUseNewTable: 'boostUseNewTable',
  consumerUseGlobalSpecials: 'scUseGlobalSpecials',
  consumerBizAdminSunsetting: 'scBizAdminSunsetting',
  // This is named the same as the business flag but it's in the consumer project
  consumerSpecialsCustomBadge: 'scSpecialsCustomBadge',
  consumerFinalSunsetting: 'scFinalSunsetting',

  /** Okay Bloomers Flags */
  obImageBannerCarousel: 'obImageBannerCarousel',

  /** DM Flags */
  dmStackAdaptStoresEnabled: 'dmStackAdaptFrontendPixelStoresEnabled',
  dmAutoRefreshEnabled: 'dmAutoRefreshEnabled',
  dmVirtualBudtenderEnabled: 'dmVirtualBudtenderEnabled',

  /** CRM Flag */
  bbCrmTracking: 'bbCrmTracking',
} as const;
